import React from "react";
import { v4 as uuid } from "uuid";
import { SiFacebook, SiInstagram, SiLinkedin } from "react-icons/si";
import "react-responsive-carousel/lib/styles/carousel.css";
import { Carousel } from "react-responsive-carousel";
import { useTranslation } from "react-i18next";

import "./style2.css";

export const Referencias = () => {
	const [t] = useTranslation("global");

	const data = [
		{
			id: "421658h",
			name: "Lic. Luis Espinoza",
			job: "Senior Developer",
			photo:
				"https://res.cloudinary.com/devsing/image/upload/v1654288817/Portfolio/luis_xmpzxg.jpg",
			socialMedia: [
				{
					link: (
						<SiLinkedin
							className="m-3 text-2xl"
							key={uuid()}
							onClick={() =>
								window.location.href(
									"https://www.linkedin.com/in/luisespinoza90/"
								)
							}
						/>
					),
				},
			],
		},
		{
			id: "4hfg658h",
			name: "Lic. Asuncion García",
			job: "Mercadotecnista",
			photo:
				"https://res.cloudinary.com/devsing/image/upload/v1654288812/Portfolio/tia_ymma3v.jpg",
			socialMedia: [
				{ face: <SiFacebook className="m-3 text-2xl" key={uuid()} /> },
				{ insta: <SiInstagram className="m-3 text-2xl" key={uuid()} /> },
			],
		},
		{
			id: "4812894hf8h",
			name: "Msc. Marlon Rosales",
			job: "Teacher in a University UNAN, specialist in Networking and Programming Robotic",
			photo:
				"https://res.cloudinary.com/devsing/image/upload/v1660518945/Portfolio/128878421_3735282013199586_6913118281804705291_n_ljfsns.jpg",
			socialMedia: [
				{ face: <SiFacebook className="m-3 text-2xl" key={uuid()} /> },
			],
		},
		{
			id: "4h158651f8h",
			name: "Daniel Calvo",
			job: "CEO of POLPOCR Data analysit and software development",
			photo:
				"https://res.cloudinary.com/devsing/image/upload/v1660519154/Portfolio/1614636961227_uljint.jpg",
			socialMedia: [
				{
					face: (
						<SiLinkedin
							className="m-3 text-2xl"
							key={uuid()}
							onClick={() =>
								window.open("https://www.linkedin.com/in/dcalvom/")
							}
						/>
					),
				},
			],
		},
	];

	return (
		<>
			<section className="references bg-gray-900" id="references">
				<div className="max-width">
					<h2 className="font-Montserrat text-center font-bold text-2xl text-yellow-400">
						{t("My-references")}
					</h2>
					<br />
					<Carousel showThumbs={false}>
						{data.map((item, index) => (
							<div className="card shadow-lg rounded-2xl" key={index}>
								<div className="box">
									<img src={item.photo} alt={item.name} />
									<div className="text font-Poppins">{item.name}</div>
									<p className="font-Poppins font-medium">{item.job}</p>
									<div className="flex justify-center items-center my-2">
										{item.socialMedia.map(
											(social) => social.face && social.face
										)}
										{item.socialMedia.map(
											(social) => social.insta && social.insta
										)}
										{item.socialMedia.map(
											(social) => social.link && social.link
										)}
									</div>
								</div>
							</div>
						))}
					</Carousel>
				</div>
			</section>
		</>
	);
};
